import { normalizeModel3DMorphPack, type Model3DMorphPack } from '@nxorbit/shared-schema';

export function siblingExpressionJsonUrls(modelPath: string): string[] {
  try {
    const url = new URL(modelPath);
    const parts = url.pathname.split('/');
    const filename = parts.pop() ?? '';
    const stem = filename.replace(/\.(glb|fbx)$/i, '');
    const basePath = parts.join('/');
    const candidates = [`${stem}.expressions.json`, 'expressions.json'];
    return candidates.map((name) => {
      const next = new URL(url.toString());
      next.pathname = `${basePath}/${name}`;
      return next.toString();
    });
  } catch {
    return [];
  }
}

export async function loadSiblingMorphPack(modelPath: string): Promise<{ pack: Model3DMorphPack; url: string } | null> {
  for (const url of siblingExpressionJsonUrls(modelPath)) {
    const res = await fetch(url, { credentials: 'omit' }).catch(() => null);
    if (!res?.ok) continue;
    const body = await res.json().catch(() => null);
    const pack = normalizeModel3DMorphPack(body);
    if (pack) return { pack, url };
  }
  return null;
}
